<template>
  <div>
    <a-modal
      v-model:visible="open"
      @cancel="handleCancel"
      :footer="null"
      style="top: 230px"
      width="418px"
      :maskClosable="false"
    >
      <div class="modal-login vcode-content">
        <!-- <div class="modal-login-title">{{ t('IdentityCheck') }}</div> -->
        <div class="switch-login" v-if="showFormlogin == 1">
          <span
            :class="loginType == 'phone' ? 'act' : ''"
            class="pointer"
            @click="checkType('phone')"
          >
            {{ t("PhoneValidation") }}
          </span>
          <span class="line"></span>
          <span
            :class="loginType == 'emall' ? 'act' : ''"
            class="pointer"
            @click="checkType('emall')"
          >
            {{ t("EmailVerification") }}
          </span>
        </div>

        <div class="emall-set" v-if="showFormlogin == 2">
          <span>
            {{ t("EmailRegistration") }}
          </span>
        </div>

        <div class="emall-set" v-if="showFormlogin == 3 || showFormlogin == 4">
          <span>
            {{ t("ResetPassword") }}
          </span>
        </div>

        <!-- 手机号校验 -->

        <a-form
          v-if="loginType === 'phone' && showFormlogin === 1"
          class="login-form"
          :model="formState"
          name="basic"
          :hideRequiredMark="true"
          autocomplete="off"
          @finish="handleSubmit"
          ref="loginFormRef"
        >
          <a-form-item
            name="tel"
            :rules="[
              { required: true, validator: handleCheckPhone, trigger: 'blur' },
            ]"
          >
            <a-input
              class="phone-input"
              v-model:value="formState.tel"
              :placeholder="t('phoneNumber')"
              :maxlength="11"
            />
          </a-form-item>
          <a-form-item
            name="captchaCode"
            :rules="[
              { required: true, trigger: 'blur', message: '请输入图形验证码' },
            ]"
          >
            <img :src="captcha.img" alt="" class="captcha-img" />
            <a-button
              @click="refreshCaptcha"
              size="middle"
              type="link"
              class="send-code"
              :disabled="seconds < 120"
              >刷新</a-button
            >
            <a-input
              class="phone-input"
              v-model:value="formState.captchaCode"
              placeholder="请输入图形验证码"
              :maxLength="4"
            />
          </a-form-item>
          <a-form-item
            name="code"
            :rules="[
              { required: true, validator: handleCheckCode, trigger: 'blur' },
            ]"
          >
            <div class="code-wrapper">
              <a-input
                v-model:value="formState.code"
                :placeholder="t('phoneCode')"
                class="code-input"
                :bordered="false"
                :maxlength="6"
              />
              <a-button
                @click="handleSendCode"
                size="middle"
                type="link"
                class="send-code"
                :disabled="seconds < 120"
                >{{ btnText }}</a-button
              >
            </div>
          </a-form-item>
          <a-button
            class="btn"
            html-type="submit"
            type="primary"
            :disabled="codeSubmitFlag"
          >
            {{ t("submit") }}
          </a-button>
          <div class="submit-tip">
            {{ t("noSMS") }} <br />
            <!-- {{ t("privacy") }}
            <span class="pointer" @click="toPrivacy"
              >《{{ t("PrivacyPolicy") }}》</span
            > -->
          </div>
        </a-form>

        <!-- 邮箱校验 -->

        <a-form
          v-if="loginType === 'emall' && showFormlogin === 1"
          class="login-form"
          :model="formEmallState"
          name="Emall"
          :hideRequiredMark="true"
          autocomplete="off"
          @finish="handleEmallSubmit"
          :rules="rules1"
          ref="EmallFormRef"
        >
          <a-form-item name="emall">
            <a-input
              class="phone-input"
              v-model:value="formEmallState.emall"
              :placeholder="t('emall')"
            />
          </a-form-item>
          <a-form-item name="password">
            <div class="code-wrapper">
              <a-input
                v-model:value="formEmallState.password"
                :placeholder="t('password')"
                class="code-input"
                type="password"
                :bordered="false"
              />
            </div>
          </a-form-item>
          <a-button
            class="btn"
            html-type="submit"
            type="primary"
            :disabled="emallSubmitFlag"
          >
            {{ t("submit") }}
          </a-button>
          <div class="reback-codelogin">
            <span class="pointer reback-item" @click="toRetrieve">{{
              t("EmailRegistration")
            }}</span>
            <span class="pointer reback-item" @click="toReset">{{
              t("ResetPassword")
            }}</span>
          </div>
          <!-- <div class="submit-tip">
            {{ t("privacy") }}
            <span class="pointer" @click="toPrivacy"
              >《{{ t("PrivacyPolicy") }}》</span
            >
          </div> -->
        </a-form>

        <!-- 邮箱注册 -->
        <a-form
          v-if="showFormlogin === 2"
          :model="setPwdForm"
          class="login-form"
          name="setPwd"
          ref="setPwdRef"
          :hideRequiredMark="true"
          autocomplete="off"
          :rules="rules2"
          @finish="setPwdAction"
        >
          <a-form-item name="emall">
            <a-input
              class="phone-input"
              v-model:value="setPwdForm.emall"
              :placeholder="t('emall')"
            />
          </a-form-item>
          <a-form-item name="password1">
            <a-input
              class="phone-input"
              type="password"
              v-model:value="setPwdForm.password1"
              :placeholder="t('password')"
            />
          </a-form-item>
          <a-form-item name="password2">
            <a-input
              class="phone-input"
              type="password"
              v-model:value="setPwdForm.password2"
              :placeholder="t('ConfirmPassword')"
            />
          </a-form-item>
          <a-button
            class="btn"
            html-type="submit"
            type="primary"
            :disabled="setPwdSubmitFlag"
          >
            {{ t("submit") }}
          </a-button>
          <div class="reback-codelogin">
            <span class="pointer reback-item" @click="setback">{{
              t("back")
            }}</span>
          </div>
          <div class="submit-tip">
            {{ t("qqrnsrdyx") }}
          </div>
        </a-form>

        <!-- 重置邮箱密码 -->
        <a-form
          v-if="showFormlogin === 3"
          :model="resetPwdForm"
          class="login-form"
          name="resetPwdPwd"
          ref="resetPwdPwdRef"
          :hideRequiredMark="true"
          autocomplete="off"
          :rules="rules3"
          @finish="resetPwdAction"
        >
          <a-form-item name="emall">
            <a-input
              class="phone-input"
              v-model:value="resetPwdForm.emall"
              :placeholder="t('emall')"
            />
          </a-form-item>
          <a-button
            class="btn"
            html-type="submit"
            type="primary"
            :disabled="resetPwdSubmitFlag"
          >
            {{ t("submit") }}
          </a-button>
          <div class="reback-codelogin">
            <span class="pointer reback-item" @click="setback">{{
              t("back")
            }}</span>
          </div>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, reactive, defineExpose, defineEmits } from "vue";
import store from "@/store";
import { message } from "ant-design-vue";
import {
  sendCode,
  loginApi,
  addByEmailApi,
  emallLoginApi,
  getCaptchaAuth,
} from "@/api/user";
import { sendResetPasswordsApi } from "@/api/meeting";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const emits = defineEmits(["loginSuccess"]);
const open = ref(false);
let origin = "";
// 表单
const loginFormRef = ref(null);
const formState = reactive({
  tel: "",
  code: "",
  captchaCode: "",
});
const captcha = ref({
  img: "",
  captchaKey: "",
});
const refreshCaptcha = async () => {
  try {
    const { results } = await getCaptchaAuth();
    captcha.value = { ...results };
    formState.captchaCode = "";
  } catch (error) {
    console.error(error);
    message.error("获取图形验证码失败");
  }
};
const rules1 = {
  emall: [
    {
      required: true,
      validator: checkEmail,
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
};

const rules2 = {
  emall: [
    {
      required: true,
      validator: checkEmail,
      trigger: "blur",
    },
  ],
  password1: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
  password2: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
};

const rules3 = {
  emall: [
    {
      required: true,
      validator: checkEmail,
      trigger: "blur",
    },
  ],
  code: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
  password1: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
  password2: [
    {
      required: true,
      validator: checkFormValue,
      trigger: "blur",
    },
  ],
};

const formEmallState = reactive({
  emall: "",
  password: "",
});

const setPwdForm = reactive({
  emall: "",
  password1: "",
  password2: "",
});

const resetPwdForm = reactive({
  emall: "",
  password1: "",
  password2: "",
  code: "",
});

let loginType = ref("phone");
let showFormlogin = ref(1);

const toRetrieve = () => {
  showFormlogin.value = 2;
  initsetEmall();
};

const toReset = () => {
  initReset();
  showFormlogin.value = 3;
};

const setback = () => {
  showFormlogin.value = 1;
  initReset();
  initEmall();
};

const meetingConfig = ref({});
const showModal = async () => {
  meetingConfig.value = localStorage.getItem("meetingConfig")
    ? JSON.parse(localStorage.getItem("meetingConfig"))
    : {};
  origin = `CONFERENCE_ID_${meetingConfig.value.platformId}`;
  showFormlogin.value = 1;
  loginType.value = "phone";
  open.value = true;
  await refreshCaptcha();
  btnText.value = t("sendCode");
};

// 校验规则
function handleCheckPhone() {
  if (/^1[3456789]\d{9}$/.test(formState.tel)) {
    return Promise.resolve();
  } else if (!formState.tel) {
    return Promise.reject(t("phoneNumber"));
  } else {
    return Promise.reject(t("ValidPhoneNumber"));
  }
}

async function checkEmail(_rule, value) {
  if (
    /^(?=.{1,64}@)[\w!#$%&'*+-/=?^`{|}~]+(?:\.[\w!#$%&'*+-/=?^`{|}~]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/.test(
      value,
    )
  ) {
    return Promise.resolve();
  } else if (!value) {
    return Promise.reject(t("emall"));
  } else {
    return Promise.reject(t("ValidEmall"));
  }
}

async function checkFormValue(_rule, value) {
  if (_rule.field === "password" || _rule.field === "password1") {
    if (!value) {
      return Promise.reject(t("password"));
    } else {
      return Promise.resolve();
    }
  }
  if (_rule.field === "password2") {
    if (!value) {
      return Promise.reject(t("ConfirmPassword"));
    } else {
      return Promise.resolve();
    }
  }

  if (_rule.field === "code") {
    if (!value) {
      return Promise.reject(t("emailVerificationcode"));
    } else {
      return Promise.resolve();
    }
  }
}

function handleCheckCode() {
  if (/^\d{6}$/.test(formState.code)) {
    return Promise.resolve();
  } else if (!formState.code) {
    return Promise.reject(t("ValidCode"));
  }
}

const btnText = ref(t("sendCode"));
const seconds = ref(120);
const codeSubmitFlag = ref(false);
let inter = null;
const _timer = () => {
  inter = setInterval(() => {
    seconds.value--;
    btnText.value = `${seconds.value} ${t("again")}`;
    if (seconds.value <= 0) {
      clearInterval(inter);
      codeSubmitFlag.value = false;
      btnText.value = t("sendCode");
      seconds.value = 120;
    }
  }, 1000);
};
// 获取验证码
const handleSendCode = async () => {
  const valid = await loginFormRef.value
    .validateFields(["tel", "captchaCode"])
    .catch(() => false);
  if (!valid) {
    return;
  }
  if (seconds.value < 120) {
    return;
  }
  loginFormRef.value.validateFields("tel").then(async () => {
    try {
      const params = {
        phone: formState.tel,
        smsSource: "YM_BRAIN_HEALTH",
        type: "pcStudentLogin",
        captchaKey: captcha.value.captchaKey,
        captchaCode: formState.captchaCode,
      };
      await sendCode(params);
      message.success(t("vcss"));
      // 定时器
      _timer();
    } catch (error) {
      console.error(error);
      message.error(t("yzmsssb"));
    }
  });
};

const handleCancel = () => {
  loginFormRef.value && loginFormRef.value.resetFields();
  open.value = false;
};
//提交表单
const handleSubmit = async () => {
  codeSubmitFlag.value = true;
  const params = {
    phone: formState.tel,
    code: formState.code,
    source: origin,
    platformId: meetingConfig.value.platformId,
  };
  try {
    const { results } = await loginApi(params);
    codeSubmitFlag.value = false;
    if (results.token) {
      localStorage.setItem("token", results.token.split(" ")[1]);
      await store.dispatch("user/getUserInfoAction");
    }
    message.success(t("yycg"));
    handleCancel();
    emits("loginSuccess");
  } catch (error) {
    console.log(error);
    codeSubmitFlag.value = false;
    message.error(t("yysb"));
  }
};

// 邮箱登录

const checkType = async (val) => {
  loginType.value = val;
  initEmall();
  initformState();
};

const initEmall = () => {
  (formEmallState.emall = ""), (formEmallState.password = "");
};

const initsetEmall = () => {
  (setPwdForm.emall = ""), (setPwdForm.password1 = "");
  setPwdForm.password2 = "";
};

const initReset = () => {
  resetPwdForm.emall = "";
  resetPwdForm.password1 = "";
  resetPwdForm.password2 = "";
  resetPwdForm.code = "";
};

const initformState = () => {
  formState.tel = "";
  formState.code = "";
  formState.captchaCode = "";
};

const emallSubmitFlag = ref(false);
const handleEmallSubmit = async () => {
  emallSubmitFlag.value = true;
  try {
    let params = {
      email: formEmallState.emall,
      password: formEmallState.password,
    };
    const { results } = await emallLoginApi(params);
    if (results.token) {
      localStorage.setItem("token", results.token.split(" ")[1]);
      await store.dispatch("user/getUserInfoAction");
    }
    message.success(t("yycg"));
    open.value = false;
    emits("loginSuccess");
  } catch (error) {
    console.log(error);
  } finally {
    emallSubmitFlag.value = false;
  }
};

const setPwdSubmitFlag = ref(false);
const setPwdAction = async () => {
  setPwdSubmitFlag.value = true;
  try {
    let params = {
      email: setPwdForm.emall,
      newPassword1: setPwdForm.password1,
      newPassword2: setPwdForm.password2,
      source: "2026BHCEmail",
    };
    await addByEmailApi(params);
    showFormlogin.value = 1;
    loginType.value = "emall";
    message.success(t("zccg"));
    initEmall();
    initsetEmall();
  } catch (error) {
    console.log(error);
  } finally {
    setPwdSubmitFlag.value = false;
  }
};

const resetPwdSubmitFlag = ref(false);
const resetPwdAction = async () => {
  resetPwdSubmitFlag.value = true;
  try {
    let params = {
      email: resetPwdForm.emall,
    };
    await sendResetPasswordsApi(params);
    message.success(t("checkEmall"));
    initReset();
  } catch (error) {
    console.log(error);
  } finally {
    resetPwdSubmitFlag.value = false;
  }
};

// const toPrivacy = () => {
//   router.push({
//     name: "Privacy",
//   });
// };

defineExpose({ showModal });
</script>

<style lang="less">
.vcode-content {
  padding-top: 42px;
  padding-bottom: 42px;
  .modal-login-title {
    height: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #333;
    line-height: 25px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 35px;
  }
  .login-form {
    width: 250px;
    margin: 0 auto;
    text-align: center;
  }
  .phone-input {
    width: 240px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
  }
  .code-wrapper {
    display: inline-flex;
    align-items: center;
    width: 240px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
    position: relative;
    .code-input {
      height: 100%;
    }
    .send-code {
      color: @theme-color;
    }
  }

  .btn {
    width: 240px;
    height: 36px;
    border-radius: 4px;
    background: @theme-color;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    border: none;
    &:hover {
      background: @theme-color;
    }
  }
  .submit-tip {
    margin-top: 20px;
    font-size: 12px;
    span {
      color: @theme-color;
    }
  }
}

.emall-set {
  margin: 0px auto 48px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
}

.switch-login {
  margin: 0px auto 48px;
  font-size: 14px;
  font-weight: 400;
  color: #b1b1b3;
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;

  .line {
    margin: 0 12px;
    display: inline-block;
    width: 1px;
    height: 12px;
    border: 1px solid #b1b1b3;
    box-sizing: border-box;
  }

  .act {
    font-weight: 600;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
  }
}
.reback-codelogin {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  .reback-item {
    color: @theme-color;
  }
}
</style>
